import { IsNumber, IsString } from 'class-validator';

export class SongListings {
    @IsNumber()
    id!: number;
    @IsNumber()
    customField!: number;
    @IsString()
    listingArea!: string;
    @IsString()
    listingCode!: string;
    @IsString()
    listingKey!: string;
    @IsString()
    listingText!: string;
    @IsNumber()
    totalRows!: number;
}
